module.exports = __webpack_public_path__ + "static/media/loginMarcaPonto.46b37254.jpg";